/* SPELLROO perf: runs inline callbacks queued with window.srLoaded() (see snippets/global-script.liquid).
   Loaded with defer as the last theme script in <body>, so it executes after every other deferred
   script (theme.js, recently-viewed-product.js, search-by-all-types, currency plugins ...) and
   still before DOMContentLoaded. */
(function () {
  if (typeof window.__srLoadedFlush === 'function') window.__srLoadedFlush();
})();
